import { render, staticRenderFns } from "./NotificacaoSolicitacaoRetirada.vue?vue&type=template&id=9e7549ae"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports